import styled, { themeGet } from "../../../styled";

export const StyledWrap = styled.div<{ backgroundColor: string }>`
  padding: 20px;
  button {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-family: ${themeGet("fonts.interUi")};
    font-weight: 500;
  }
  .composeBtn {
    background-color: ${(props) => props.backgroundColor};
    border-color: ${(props) => props.backgroundColor};
  }
`;
